import {Component, Input, OnInit} from '@angular/core';
import {Log} from 'ng2-logger';
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {StrainMeasurement} from "@app/strain/common/models/strain-registry-measurement.model";

@Component({
    selector: 'app-strain-report-selection-form',
    templateUrl: './strain-report-selection-form.component.html',
    styleUrls: ['./strain-report-selection-form.component.scss']
})
export class StrainReportSelectionFormComponent implements OnInit {
    _logger = Log.create(StrainReportSelectionFormComponent.name);

    @Input() showValidations = false;
    @Input() isLoading = false;
    @Input() similarMeasurements: StrainMeasurement[];
    @Input() reportSelection: any;
    @Input() isEditMode: boolean;

    public form: UntypedFormGroup;

    isSelected = true;

    constructor(private fb: UntypedFormBuilder) {

    }

    ngOnInit() {
        this._logger.info("ngOnInit:: Preparing strain configuration form");

        this.initForm(this.isEditMode);
    }

    initForm(isEditMode) {
        this.showValidations = false;

        this.form = this.fb.group({
            isNewReport: [true],
            templateReport: [{value: null, disabled: true}, Validators.required],
        });

        if (isEditMode && this.reportSelection) {
            this.form = this.fb.group({
                isNewReport: this.reportSelection.isNewReport,
                templateReport: [this.reportSelection.templateReport, Validators.required],
            });
        }
    }

    control(name: string): UntypedFormControl {
        return this.form.get(name) as UntypedFormControl;
    }

    value() {
        return this.form.value;
    }

    valid() {
        return this.form && this.form.valid;
    }

    reset() {
        this._logger.info("resetForm:: Resetting line details form");
        this.form.reset();
    }


    onSelectNewReport(value: boolean) {
        this.control('isNewReport').setValue(value);
        this.control('isNewReport').reset(value);

        if (value) {
            this.control('templateReport').disable();
        } else {
            this.control('templateReport').enable();
        }
    }
}
